import * as React from 'react'
import toast from "react-hot-toast";

interface ToastMessageProps {
    message: string
    t: any
}

const ToastMessage: React.FC<ToastMessageProps> = ({ message, t }) => {
    return (
        <div className="d-flex flex-row" >
            <div className={`d-flex `} style={{ flex: "4 1 0%" }}>
                <span>   {message}</span>
            </div>
            <div className=" " style={{ width: 20 }}>
                <button className="btn btn-link" style={{ position: "absolute", top: 8, right: 8, padding: 0, margin: 0 }} onClick={() => toast.dismiss(t.id)} >
                    <i className="fa fa-close" style={{ color: "#b1b1b1" }} />
                </button>
            </div>
        </div>
    )
}

export default ToastMessage
